// useOneAtATime — an action that runs one at a time: while its run is in
// flight the action is `null` (the control shows disabled), and a second
// call that slips in before the re-render is ignored. So a double click is
// one intent (#249). The in-flight flag is view-ephemeral: it does not
// survive a reload and carries no domain meaning (ui-as-projection.md).

export { useOneAtATime };

import { useRef, useState } from "react";

const useOneAtATime = (run: () => Promise<unknown>): (() => void) | null => {
    const [busy, setBusy] = useState(false);
    // The guard itself: a ref, so two calls in one tick still see it.
    const running = useRef(false);
    if (busy) return null;
    return () => {
        if (running.current) return;
        running.current = true;
        setBusy(true);
        run().finally(() => {
            running.current = false;
            setBusy(false);
        });
    };
};
